import { render, staticRenderFns } from "./evaluacion-impacto-ver.vue?vue&type=template&id=6155b606&scoped=true&"
import script from "./evaluacion-impacto-ver.vue?vue&type=script&lang=js&"
export * from "./evaluacion-impacto-ver.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-impacto-ver.vue?vue&type=style&index=0&id=6155b606&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6155b606",
  null
  
)

export default component.exports